import {
    FEATURES_TAB_REQUEST,
    FEATURES_TAB_RESULT,
} from 'Redux/actionTypes';

export const featureTabRequest = (data) => ({
    type: FEATURES_TAB_REQUEST,
    payload: data
})

export const featureTabResult = (result) => ({
    type: FEATURES_TAB_RESULT,
    payload: result
})